import * as H from "history";
import * as React from "react";
import { match as Match } from "react-router";
import { PastCaseProject } from "src/domain/model/past_case_project";
import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";
import Progress from "../../../common/organism/progress";
import CustomerMyPageEditComponent from "./customer_mypage_edit";
import CustomerMyPageEmailUpdateComponent from "./customer_mypage_email_update";
import CustomerMyPageInfoComponent from "./customer_mypage_info";
import CustomerMyPagePasswordUpdateComponent from "./customer_mypage_password_update";
import JobCareerEditComponent from "./job_career_edit";
import PastProjectEditComponent from "./past_project_edit";
import CustomerMypagePDFInfoComponent from "./pdf/customer_mypage_main_pdf";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  location: H.Location;
  match: Match<{ action: string }>;
  customer: Customer | null;
  jobCareers: JobCareer[];
  pastCaseProjects: PastCaseProject[];
  blobURL: string;
  handleUpdateCustomerSubmit: (values: any) => void;
  handleUpdatePasswordSubmit: (values: any) => void;
  handleUpdateEmailSubmit: (values: any) => void;
  handleGenerateCustomerPDF: () => void;
  handleDestroyCustomerPDF: () => void;
}

const CustomerMypageComponent: React.FC<IProps> = (props) => {
  const {
    isInit,
    isLoading,
    location,
    match,
    customer,
    jobCareers,
    pastCaseProjects,
    blobURL,
    handleUpdateCustomerSubmit,
    handleUpdatePasswordSubmit,
    handleUpdateEmailSubmit,
    handleGenerateCustomerPDF,
    handleDestroyCustomerPDF,
  } = props;

  const pathName: string = location.pathname;
  const action: string | null = match.params ? match.params.action : null;

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  let res: JSX.Element;

  switch (true) {
    case /^\/customer\/mypage\/customer/.test(pathName): {
      if (action === "_edit") {
        // 編集画面
        res = (
          <CustomerMyPageEditComponent
            isLoading={isLoading}
            customer={customer}
            jobCareers={jobCareers}
            pastCaseProjects={pastCaseProjects}
            handleUpdateCustomerSubmit={handleUpdateCustomerSubmit}
          />
        );
      } else if (action === "_edit_job_career") {
        // 編集画面
        res = (
          <JobCareerEditComponent
            isLoading={isLoading}
            customer={customer}
            jobCareers={jobCareers}
            pastCaseProjects={pastCaseProjects}
            handleUpdateCustomerSubmit={handleUpdateCustomerSubmit}
          />
        );
      } else if (action === "_edit_past_project") {
        // 編集画面
        res = (
          <PastProjectEditComponent
            isLoading={isLoading}
            customer={customer}
            jobCareers={jobCareers}
            pastCaseProjects={pastCaseProjects}
            handleUpdateCustomerSubmit={handleUpdateCustomerSubmit}
          />
        );
      } else if (action === "_pdf") {
        //    pdf 画面
        res = (
          <CustomerMypagePDFInfoComponent
            isLoading={isLoading}
            blobURL={blobURL}
            handleGenerateCustomerPDF={handleGenerateCustomerPDF}
            handleDestroyCustomerPDF={handleDestroyCustomerPDF}
          />
        );
      } else {
        // 通常画面
        res = (
          <CustomerMyPageInfoComponent
            isLoading={isLoading}
            customer={customer}
            jobCareers={jobCareers}
            pastCaseProjects={pastCaseProjects}
          />
        );
      }

      break;
    }

    case /^\/customer\/mypage\/password/.test(pathName): {
      res = (
        <CustomerMyPagePasswordUpdateComponent
          isLoading={isLoading}
          handleUpdatePasswordSubmit={handleUpdatePasswordSubmit}
        />
      );

      break;
    }

    case /^\/customer\/mypage\/email/.test(pathName): {
      res = (
        <CustomerMyPageEmailUpdateComponent
          isLoading={isLoading}
          handleUpdateEmailSubmit={handleUpdateEmailSubmit}
        />
      );

      break;
    }

    default: {
      res = <div />;
    }
  }

  return res;
};

export default CustomerMypageComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/customer_mypage.tsx